import { configRefs } from '@utils/constants';
import { authenticateComponentFrameworkRequest } from './util.authenticate-component-framework-request.js';

async function shareComponentEntry(user, entry, message) {
  if (!entry.envelope.objectID) {
    throw new Error("shareComponentEntry(): Cannot share entries that have not yet been synced to the backend");
  }
  const url = `${await configRefs.apis.userdata.get()}/api/ComponentEntries/${encodeURIComponent(entry.envelope.objectID)}/Share`;
  const res = await fetch(...authenticateComponentFrameworkRequest(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json; charset=utf-8"
    },
    body: JSON.stringify({
      author: {
        type: "elev",
        id: user?.id ?? entry.envelope.userID
      },
      content: message
    })
  }));
  if (!res.ok) {
    throw new Error("shareComponentEntry.saveThroughGateway(): Failed to save component");
  }
  return entry;
}

export { shareComponentEntry };
//# sourceMappingURL=request.share-component-entry.js.map
